<template>
  <v-card>
    <v-card-title>
      GridDojo
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="rows"
    >
    </v-data-table>
    <v-card-text>
      <v-row>
        <v-col cols="1">
          <v-select
          v-model="method"
          :items="[
            {value: 'get', text: 'GET'},
            {value: 'put', text: 'PUT'},
            {value: 'post', text: 'POST'},
            {value: 'patch', text: 'PATCH'},
            {value: 'delete', text: 'DELETE'}
          ]"
          label="Method"
        ></v-select>
        </v-col>
        <v-col>
          <v-text-field
            v-model="go"
            clearable
            label="Url (optional)"
            placeholder="URL like /api/v1/rights/?bol=347&amp;limit=50&amp;page=5"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="['post','patch'].includes(method)">
        <v-col>
          <v-textarea
          outlined
          v-model="body"
          label="Request body (raw json)"
        ></v-textarea>
        </v-col>
      </v-row>

      <v-btn class="mt-5" @click="fetch">Execute</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import API from '@/plugins/api'
import {mapGetters} from 'vuex'
import capitalize from 'lodash/capitalize'

export default {
  data () {
    return {
      headers: [],
      rows: [],
      go: '',
      body: '',
      method: 'get'
    }
  },

  computed: {
    ...mapGetters('app',['locale'])
  },

  methods: {
    fetch () {

      if (this.go==='') {
        // eslint-disable-next-line no-alert
        alert('No url entered')
        return
      }
      API.anywhere(this.method,this.go,this.body)
        .then(res => {
          // Clear results
          this.headers=[]
          this.rows=[]
          // Handle headers
          if (res.data.meta && res.data.meta.headings && res.data.meta.headings.length) {
            res.data.meta.headings.forEach(h => {
              let col = Object.keys(h)[0]
              this.headers.push({ text: h[col].label[capitalize(this.locale || 'en')], value: col })
            })
          }
          // Set rows
          this.rows = res.data.rows
        })
        .catch(error => {
          console.log(error)
        })
    }

  }
}
</script>

<style>

</style>